import React from "react";
import "../css/Grid.css";
import {userButton} from './UserButton.js';


//Do I need wpApiKey here?
const Header = ({ user, wpApiKey }) => {
const userButtons = user.userButtonList
  .slice() // optional: clone the array to avoid mutating the original
  .sort((a, b) => a.order - b.order)
  .map((item, index) => (
    <div key={index}>
      {userButton(user.userId, item.buttonId, item.url, item.text)}
    </div>
  ));


  const handle = `@${user.username}`;
  return (
    <header className="gtl-header">
    	<div className="avatarRow">
    		{user.profilePicUrl && (
    			<img src={user.profilePicUrl} alt="avatar" className="avatar" />
    		)}
    		<p className="ig-handle">{handle}</p>
    	</div>

      <p className="call-to-action">
        <b>{user.welcome}</b>
      </p>
      <p className="homepage-disclosure">{user.profilePageDisclosure}</p>
	{userButtons}
    </header>
  );
};

export default Header;
